import { config, helpers, i18n, React, ui } from "aaa";
import { Loan } from "models/Loan";
import { User } from "models/User";
import { Currency } from "util/Currency";



type IProps = i18n.InjectedIntlProps & {
    user: User,
    loan: Loan,
};

export class Mail extends React.Component<IProps, {}> {

    renderCurrency(currency: Currency, label: i18n.IDS) {
        if (currency.value > 0) {
            return <span>{ui.__(label)}: {currency.toStringShort()} <br /></span>;
        }
    }

    render() {
        const __ = ui.__;
        const user = this.props.user;
        const loan = this.props.loan;
        return (
            <div>
                <h2>{__("loanSummary")}</h2>
                <div>
                    <p>{__("loan.amount")}: {helpers.numberToCurrencyString(loan.amount)}</p>
                    <p>{__("loan.duration")}: {loan.durationInYears} {__("years")}</p>
                    <p>{__("loan.amountTotal")}: {helpers.numberToCurrencyString(loan.totalAmount)}</p>
                    <p />
                    <p>{__("loan.interestRate")}: {loan.interestRate.toLocaleString(config.LOCALE)}%</p>
                    <p>{__("loan.interestRateEffective")}: {loan.interestRateEffective.toLocaleString(config.LOCALE)}%</p>
                    <p>{__("loan.monthlyRate")}: {helpers.numberToCurrencyString(loan.monthlyRate)}</p>
                </div>

                <h2>{__("header.baseData")}</h2>
                <div>
                    <p>{__("salutation")}: {user.salutation}</p>
                    <p>{__("title")}: {user.title}</p>
                    <p>{__("lastName")}: {user.lastName}</p>
                    <p>{__("firstName")}: {user.firstName}</p>
                    <p />
                    <p>{__("addressCountry")}: {user.country}</p>
                    <p>{__("address")}: {user.address}</p>
                    <p>{__("zipCode")}: {user.zipCode}</p>
                    <p>{__("residence")}: {user.residence}</p>
                    <p />
                    <p>{__("birthDate")}: {user.birthDate}</p>
                </div>

                <div>
                    <p>{__("maritalStatus")}: {user.maritalStatus}</p>
                    <p>{__("peopleInHousehold")}: {user.peopleInHousehold}</p>
                    <p>{__("residenceStatus")}: {user.residenceStatus}</p>
                    <p>{__("residenceSince", { address: this.props.user.address + ", " + this.props.user.zipCode + " " + this.props.user.residence })}:
                        {user.residenceSince}</p>
                    <p>{__("citizenship")}: {user.citizenship}</p>
                    <p />
                    <p>{__("employment")}: {user.employment.employment}</p>
                    {user.employment.employmentKey === "employment.other" &&
                        <p>{__("employment.detail")}: {user.employment.employmentDetail}</p>}
                    {user.employment.employmentKey !== "employment.retired" &&
                        user.employment.employmentKey !== "employment.private" &&
                        user.employment.employmentKey !== "employment.other" &&
                        <p>
                            {__("job")}: {user.employment.job}<br />
                            {__("employer")}: {user.employment.employer}<br />
                            {__("employedSince")}: {user.employment.employedSince}<br />
                        </p>}
                </div>

                <h2>{__("header.contactInformation")}</h2>
                <div>
                    {Boolean(user.phoneNumber) &&
                        <p>{__("contact.phoneNumber")}: {user.phoneNumber}</p>}
                    <p>{__("contact.emailAddress")}: {user.emailAddress}</p>
                    <p>{__("contact.iban")}: {user.iban}</p>
                    <p>{__("contact.phoneAllowed")}: {user.phoneAllowed ? __("yes") : __("no")}</p>
                </div>

                <h2>{__("header.income")}</h2>
                <div>
                    <p>{this.renderCurrency(user.income.net, "income.net")}</p>
                    <p>{this.renderCurrency(user.income.childMoney, "income.childMoney")}</p>
                    <p>{this.renderCurrency(user.income.rent, "income.rent")}</p>
                    <p>{this.renderCurrency(user.income.other, "income.other")}</p>
                    {user.income.other.value > 0 && <p>
                        {__("income.otherDescription")}: {user.income.otherDescription}<br /></p>}
                </div>

                <h2>{__("header.expenses")}</h2>
                <div>
                    <p>{this.renderCurrency(user.expenses.rent, "expenses.rent")}</p>
                    <p>{this.renderCurrency(user.expenses.utilities, "expenses.utilities")}</p>
                    <p>{this.renderCurrency(user.expenses.otherLoans, "expenses.otherLoans")}</p>
                    <p>{this.renderCurrency(user.expenses.insurances, "expenses.insurances")}</p>
                    <p>{this.renderCurrency(user.expenses.healthInsurance, "expenses.healthInsurance")}</p>
                    {user.expenses.numberOfCars > 0 && <p>{__("expenses.numberOfCars")}: {user.expenses.numberOfCars}</p>}
                    <p>{this.renderCurrency(user.expenses.other, "expenses.other")}</p>
                    {user.expenses.other.value > 0 && <p>
                        {__("expenses.otherDescription")}: {user.expenses.otherDescription}</p>}
                </div>

                <h2>{__("header.ownerOfObject")}</h2>
                <div>
                    <p>{__("address")}: {user.objectAddress}</p>
                    <p>{__("zipCodeAndResidence")}: {user.objectZipAndResidence}</p>
                    <p />
                    <p>{__("objectDistrictCourt")}: {user.objectDistrictCourt}</p>
                    <p>{__("objectRegister")}: {user.objectRegister}</p>
                    <p>{__("objectSheetNumber")}: {user.objectSheetNumber}</p>
                </div>

                {user.hasSecondBorrower && <div>
                    <h2>{__("header.secondBorrower")}</h2>
                    <div>
                        <p>{__("salutation")}: {user.secondBorrowerSalutation}</p>
                        <p>{__("title")}: {user.secondBorrowerTitle}</p>
                        <p>{__("lastName")}: {user.secondBorrowerLastName}</p>
                        <p>{__("firstName")}: {user.secondBorrowerFirstName}</p>
                        <p>{__("birthDate")}: {user.secondBorrowerBirthDate}</p>
                        <p>{__("employment")}: {user.secondBorrowerEmployment.employment}</p>
                        {user.secondBorrowerEmployment.employmentKey === "employment.other" &&
                            <p>{__("employment.detail")}: {user.secondBorrowerEmployment.employmentDetail}</p>}
                        {user.secondBorrowerEmployment.employmentKey !== "employment.retired" &&
                            user.secondBorrowerEmployment.employmentKey !== "employment.private" &&
                            user.secondBorrowerEmployment.employmentKey !== "employment.other" &&
                            <div>
                                <p>{__("job")}: {user.secondBorrowerEmployment.job}</p>
                                <p>{__("employer")}: {user.secondBorrowerEmployment.employer}</p>
                                <p>{__("employedSince")}: {user.secondBorrowerEmployment.employedSince}</p>
                            </div>}
                        <p />
                        <p>{this.renderCurrency(user.secondBorrowerNetIncome, "income.net")}</p>
                    </div>
                </div>}

                <h2>{__("header.climatebonus")}</h2>
                <p>{__("summary.climatebonus")}: <strong>{user.wantsClimateBonus ? __("yes") : __("no")}</strong></p>

                <h2>{__("bottomBar.data")}</h2>
                <p>{__("gdpr.accepted")}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Mail.tsx